import type { PartnerType } from "./schema";

export const PARTNER_TYPE_DESCRIPTIONS: Record<PartnerType, { label: string; portalDescription: string }> = {
  lender: {
    label: "Lender",
    portalDescription: "the Lender portal, where you can review financing requests and connect with PadPulse buyers seeking loan products.",
  },
  wholesaler: {
    label: "Wholesaler",
    portalDescription: "the Wholesaler portal, where you can submit and track off-market deals you're sharing with PadPulse.",
  },
  realtor: {
    label: "Realtor",
    portalDescription: "the Realtor portal, where you can manage listings, referrals, and your Co-Living Certified profile.",
  },
  broker: {
    label: "Mortgage Broker",
    portalDescription: "the Mortgage Broker portal, where you can review buyer pre-approval requests and manage loan submissions.",
  },
  affiliate: {
    label: "Affiliate",
    portalDescription: "the Affiliate portal, where you can track your referral commissions and manage your referral link.",
  },
  founder_circle: {
    label: "Founder Circle",
    portalDescription: "the Founder Circle portal, where you can track your Founder Circle referral commissions.",
  },
  property_manager: {
    label: "Certified Property Manager",
    portalDescription: "the Certified Property Manager portal, where you can manage your CPM credentials and access PM-specific tools.",
  },
};

export interface RenderPartnerTypeChangedEmailInput {
  contactName: string;
  companyName: string;
  fromType: PartnerType;
  toType: PartnerType;
}

export interface RenderedPartnerTypeChangedEmail {
  subject: string;
  html: string;
}

export function renderPartnerTypeChangedEmail(
  input: RenderPartnerTypeChangedEmailInput,
): RenderedPartnerTypeChangedEmail {
  const firstName = (input.contactName || "").split(" ")[0] || input.contactName || "there";
  const fromInfo = PARTNER_TYPE_DESCRIPTIONS[input.fromType];
  const toInfo = PARTNER_TYPE_DESCRIPTIONS[input.toType];

  const subject = "Your partner account type was updated";
  const html = `
        <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto;">
          <div style="background-color: #0052CC; padding: 20px; text-align: center;">
            <h1 style="color: white; margin: 0;">PadPulse Partners</h1>
          </div>
          <div style="padding: 30px; background: #f9f9f9;">
            <p>Dear ${firstName},</p>
            <p>We're writing to let you know that the partner account type for <strong>${input.companyName}</strong> on PadPulse has been updated by our team.</p>
            <p><strong>Previous type:</strong> ${fromInfo.label}<br/>
               <strong>New type:</strong> ${toInfo.label}</p>
            <p>The next time you sign in, you'll be taken to ${toInfo.portalDescription}</p>
            <p>If anything from your previous portal is missing or this change wasn't expected, please reply to this email or reach us at <a href="mailto:partners@padpulse.io">partners@padpulse.io</a> and we'll sort it out.</p>
            <p>— The PadPulse Team</p>
          </div>
        </div>
      `;
  return { subject, html };
}
